import React, { useContext, useEffect, useState } from 'react'
import ExpoPlaces from './ExpoPlaces'
import Soon from './Soon'
import Finished from './Finished'
import { store } from '../../components/HOC/State'
import { translate } from '../translate'
import { axiosInstance } from '../../const/axiosInstance'
import styles from './expo.module.css'

export default function Expo() {
  const [selected, setSelected] = useState("places")
  const [image, setImage] = useState('')
  const [showImage, setShowimage] = useState(false)

  const {selectedLang} = useContext(store)
  let lang = translate[selectedLang]

  useEffect(() => {
    (async () => {
        const res = await axiosInstance.get(`/use/expo/nearest`)
        if(res.data.status){
            setImage(res.data.data[0].image)
            setShowimage(true)
        }
    })()
  }, [])

  return (
    <div className={styles['hole-expo']}>
        <div className={styles['expo-soon-image-div']}>
            <img src="/expo-image.jpg" alt='expo-image' className={styles['expo-soon-image']}/>
        </div>
        {selected === 'places' ? <ExpoPlaces/> : selected === 'future' ? <Soon from='future'/> : <Finished from='passed'/>}
    </div>
  )
}
